"use strict";

var _toConsumableArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckboxQuestion;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Checkbox = require("@mui/material/Checkbox");
var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _Button = require("@mui/material/Button");
var _Button2 = _interopRequireDefault(_Button);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
var _TextField = require("@mui/material/TextField");
var _TextField2 = _interopRequireDefault(_TextField);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CheckboxItem = (0, _styledComponents2.default)(_Button2.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n    padding: 0;\n    padding-right: 20px;\n    text-transform: none;\n    margin-top: 1px;\n  }\n"])));
function CheckboxQuestion(_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, []),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer.length > 0,
    error: error
  }, question.choices.map(function (choice) {
    return typeof choice === "string" ? {
      value: choice,
      text: choice
    } : choice;
  }).map(function (_ref4) {
    var value = _ref4.value,
      text = _ref4.text;
    var onChange = function onChange() {
      var newAnswer = answer.includes(value) ? answer.filter(function (a) {
        return a !== value;
      }) : answer.concat([value]);
      if (!question.hasOther) newAnswer = newAnswer.sort();
      changeAnswer(newAnswer);
    };
    return _react2.default.createElement(CheckboxItem, {
      role: "button",
      onClick: onChange,
      key: value
    }, _react2.default.createElement(_Checkbox2.default, {
      tabIndex: -1,
      checked: answer.includes(value),
      id: question.id ? question.id + text : ""
    }), _react2.default.createElement(_QuestionText2.default, null, text));
  }), question.hasOther && answer.concat(null).filter(function (a) {
    return !question.choices.some(function (c) {
      return c === a || (c || {}).value === a;
    });
  }).map(function (otherValue, i) {
    return _react2.default.createElement(CheckboxItem, {
      role: "button"
    }, _react2.default.createElement(_Checkbox2.default, {
      tabIndex: -1,
      onClick: function onClick() {
        if (otherValue !== null) {
          changeAnswer(answer.filter(function (a) {
            return a !== otherValue;
          }));
        } else {
          changeAnswer([].concat(_toConsumableArray(answer.slice(0, i)), [""], _toConsumableArray(answer.slice(i + 1))));
        }
      },
      checked: otherValue !== null
    }), _react2.default.createElement(_TextField2.default, {
      value: otherValue || "",
      onChange: function onChange(e) {
        changeAnswer([].concat(_toConsumableArray(answer.slice(0, i)), [e.target.value], _toConsumableArray(answer.slice(i + 1))));
      }
    }));
  }));
}